import {HierarchicNode} from '../../core/definitions/hierarchic-objects';
import {FieldParameters} from '../../core/definitions/field-parameters';
import {Reference} from '../../core/definitions/reference';

type AddHierarchicNodes = (
  parentNode: HierarchicNode,
  fieldParameters: FieldParameters,
  reference: Reference,
  page: number,
  pageSize: number,
  parentId: string,
) => Promise<void>;

/** Parent id to fetch when this node has not loaded its own children yet. */
export function unloadedNonLeafParentId(node: HierarchicNode): string | null {
  if (!node || node.is_leaf !== false || node.$$nodeType === 'loadMoreNode' || node.$$childrenLoaded) {
    return null;
  }
  if ((node.children || []).some(child => child.$$nodeType !== 'loadMoreNode')) {
    return null;
  }
  return node.artifact_id || null;
}

export async function loadUnloadedNonLeafChildren(
  node: HierarchicNode,
  fieldParameters: FieldParameters,
  reference: Reference,
  pageSize: number,
  addHierarchicNodes: AddHierarchicNodes,
): Promise<boolean> {
  const parentId = unloadedNonLeafParentId(node);
  if (!parentId) {
    return false;
  }
  node.$$childrenLoaded = true;
  await addHierarchicNodes(node, fieldParameters, reference, 0, pageSize, parentId);
  return true;
}
